import { useSidebar } from "@/hooks/useSidebar";
import Divider from "@/components/Divider";

interface Props {
  heading?: string;
}

export default function SidebarDivider({ heading }: Props) {
  const { isSidebarOpen } = useSidebar();
  const showHeading = isSidebarOpen && heading;
  return (
    <div className="w-full py-2 opacity-50">
      <Divider inset />
      {showHeading && <div className="p-4">{heading}</div>}
    </div>
  );
}
